export default __webpack_public_path__ + "static/media/plus.94e45323.svg";